module.exports = __webpack_public_path__ + "static/media/DefaultImage.e9f15eb6.png";